import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import CodeBlock from '@tiptap/extension-code-block';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';

/**
 * Get Tiptap extensions configured for documentation
 */
export const getTiptapExtensions = () => [
  StarterKit.configure({
    heading: {
      levels: [1, 2, 3],
    },
    codeBlock: false, // we use custom CodeBlock below
  }),

  // Extensions NOT included in StarterKit
  Underline,

  CodeBlock.configure({
    languageClassPrefix: 'language-',
  }),

  Link.configure({
    openOnClick: true,
    HTMLAttributes: {
      class: 'tiptap-link',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  }),

  Image.configure({
    allowBase64: true,
    inline: false,
    HTMLAttributes: {
      class: 'tiptap-image',
    },
  }),

  TaskList,

  TaskItem.configure({
    nested: true,
  }),
];
